<template>
	<b-modal ref="mdlWidgetEditor" dialog-class="sa-modal-full-height" title="Modifica Widget" @ok="handleSave" ok-title="Salva" cancel-title="Annulla" size="xl" @show="loadQueryList" scrollable>
		<div class="app-layout">
			<aside class="sidebar">
				<b-row>
					<b-col md="6">
						<b-form-group label="Titolo Widget:">
							<b-form-input v-model="mxChartConfig.title" type="text" />
						</b-form-group>
					</b-col>

					<b-col md="6">
						<b-form-group label="Visualizzazione:">
							<b-form-select v-model="mxChartConfig.graphicType" :options="graphicOptions" />
						</b-form-group>
					</b-col>
				</b-row>
				<hr />
				<h6 class="text-success small mb-3">🎨 Stile e Colori</h6>
				<b-row>
					<b-col md="12">
						<b-form-group label="Palette Colori:">
							<b-form-select v-model="mxChartConfig.colorPalette" :options="paletteOptions" />
						</b-form-group>
					</b-col>
					<!-- <b-col md="6" class="d-flex align-items-center">
						<div v-if="selectedPaletteColors" class="d-flex mt-2">
							<div v-for="color in selectedPaletteColors.slice(0, 11)" :key="color" :style="{ backgroundColor: color, width: '12px', height: '20px', borderRadius: '4px', marginRight: '4px' }"></div>
						</div>
					</b-col> -->
					<b-col md="12" class="d-flex align-items-center" style="margin-left: 19px; margin-top: -15px; margin-bottom: 12px">
						<!-- <div v-if="selectedPaletteColors" class="d-flex mt-2">
							<div v-for="color in selectedPaletteColors.slice(0, 6)" :key="color" :style="{ backgroundColor: color, width: '20px', height: '20px', borderRadius: '4px', marginRight: '4px' }"></div>
						</div> -->
						<div v-if="selectedPaletteColors" class="d-flex mt-2 flex-wrap">
							<div
								v-for="(color, index) in selectedPaletteColors"
								:key="index"
								:style="{
									backgroundColor: color,
									width: '18px',
									height: '18px',
									borderRadius: '4px',
									marginRight: '4px',
									marginBottom: '4px',
									border: '1px solid #dee2e6',
								}"
								:title="color"
							></div>
						</div>
					</b-col>
				</b-row>
				<hr />
				<h6 class="text-primary small mb-3">Mappatura Campi & Aggregazione</h6>
				<b-row>
					<b-col md="12">
						<b-form-group label="Sorgente Dati (Query):">
							<b-input-group>
								<b-form-select v-model="mxChartConfig.idQuery" value-field="id" text-field="title" :options="queryOptions">
									<template #first>
										<b-form-select-option :value="null" disabled>-- Seleziona una query --</b-form-select-option>
									</template>
								</b-form-select>

								<b-input-group-append>
									<b-button variant="primary" :disabled="!mxChartConfig.idQuery || isExecuting" @click="queryLoadData">
										<b-spinner v-if="isExecuting" small></b-spinner>
										<span v-else>⚡ Esegui</span>
									</b-button>
								</b-input-group-append>
							</b-input-group>
							<small class="text-muted" v-if="queryOptions.length > 0">
								✅ Query eseguita: trovati <strong>{{ fieldOptions.length }}</strong> campi.
							</small>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="sa-data-analysis-section-header text-primary">1. Dimensioni Principali</div>
				<b-form-group label="Campo Raggruppamento Asse X / Legenda:">
					<b-form-select v-model="mxChartConfig.xField" :options="fieldOptions"></b-form-select>
				</b-form-group>
				<div class="sa-data-analysis-section-header text-primary">2. Configurazione Serie</div>
				<div v-for="(sConfig, index) in mxChartConfig.seriesConfigs" :key="index" class="sa-data-analysis-series-item sa-data-analysis-shadow-sm">
					<span class="sa-data-analysis-remove-btn" @click="removeSeries(index)"><i class="fas fa-trash-alt"></i></span>
					<h6 class="small font-weight-bold mb-3 text-primary">Serie #{{ index + 1 }}</h6>

					<!-- <b-form-group label="Campo Sorgente:" label-class="small">
						<b-form-select v-model="sConfig.field" :options="fieldOptions" @change="onFieldChange(index)"></b-form-select>
					</b-form-group> -->
					<b-row>
						<b-col :hidden="isPie" cols="6">
							<b-form-group label="Tipo Grafico:" label-class="small">
								<b-form-select v-model="sConfig.type" :options="graphicOptions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col :hidden="!isPie" cols="6">
							<b-form-group label="Campo Valori:" label-class="small">
								<b-form-select v-model="sConfig.yvalue" :options="fieldOptions" @change="onFieldChange(index)"></b-form-select>
							</b-form-group>
						</b-col>

						<b-col cols="6" :hidden="isPie">
							<b-form-group label="Serie:">
								<b-form-select v-model="sConfig.serieField" :options="fieldOptions"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Aggregazione:" label-class="small">
								<b-form-select v-model="sConfig.agg" :options="getAvailableAgg(sConfig.yvalue)"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col cols="6" :hidden="isPie">
							<b-form-group label="Campo Valori:" label-class="small">
								<b-form-select v-model="sConfig.yvalue" :options="fieldOptions" @change="onFieldChange(index)"></b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row :hidden="!isPie">
						<b-col cols="6">
							<b-form-group label="Raggio Interno (in %):" label-class="small">
								<b-form-input v-model="sConfig.radiusInternal" type="number" />
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Raggio Esterno (in %):" label-class="small">
								<b-form-input v-model="sConfig.radiusExternal" type="number" />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row :hidden="!isPie">
						<b-col cols="12">
							<b-form-group label="Mostra Totale:" label-class="small">
								<b-form-checkbox switch v-model="sConfig.viewTotal" type="text" />
							</b-form-group>
						</b-col>
					</b-row>

					<!-- <b-row>
						<b-col cols="6">
							<b-form-group label="Aggregazione:" label-class="small">
								<b-form-select v-model="sConfig.agg" :options="getAvailableAgg(sConfig.field)"></b-form-select>
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Tipo Grafico:" label-class="small">
								<b-form-select v-model="sConfig.type" :options="graphicOptions"></b-form-select>
							</b-form-group>
						</b-col>
					</b-row> -->

					<b-row :hidden="isPie">
						<b-col cols="6">
							<b-form-group label="Etichetta Legenda:" label-class="small">
								<b-form-input v-model="sConfig.label" placeholder="Es. Totale"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Posizione Asse Y:" label-class="small">
								<b-form-select
									v-model="sConfig.secondaryY"
									:options="[
										{ value: false, text: 'Sinistro' },
										{ value: true, text: 'Destro' },
									]"
								></b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
				</div>
				<b-button :disabled="!mxChartConfig.graphicType" variant="primary" size="sm" block @click="addSeries" class="mb-4 shadow-sm"> <i class="fas fa-plus-circle mr-1"></i> Aggiungi Serie </b-button>
				<h6 class="text-info small mb-3">📏 Margini Griglia (Padding)</h6>
				<b-row>
					<b-col cols="3">
						<b-form-group label="TOP" label-class="small font-weight-bold">
							<b-form-input v-model="mxChartConfig.gridTop" type="number" placeholder="10%" size="sm" />
						</b-form-group>
					</b-col>
					<b-col cols="3">
						<b-form-group label="BOTTOM" label-class="small font-weight-bold">
							<b-form-input v-model="mxChartConfig.gridBottom" type="number" placeholder="15%" size="sm" />
						</b-form-group>
					</b-col>
					<b-col cols="3">
						<b-form-group label="LEFT" label-class="small font-weight-bold">
							<b-form-input v-model="mxChartConfig.gridLeft" type="number" placeholder="3%" size="sm" />
						</b-form-group>
					</b-col>
					<b-col cols="3">
						<b-form-group label="RIGHT" label-class="small font-weight-bold">
							<b-form-input v-model="mxChartConfig.gridRight" type="number" placeholder="4%" size="sm" />
						</b-form-group>
					</b-col>
				</b-row>
				<hr />
				<h6 class="text-muted small mb-3">Layout Responsivo</h6>
				<b-row>
					<b-col v-for="size in ['xs', 'sm', 'md', 'lg', 'xl']" :key="size">
						<b-form-group :label="size.toUpperCase()">
							<b-form-select v-model="mxChartConfig[size]" :options="gridOptions" />
						</b-form-group>
					</b-col>
				</b-row>
			</aside>

			<main class="main-container">
				<section style="height: 100%" class="content">
					<b-tabs id="tabsDashboardView" ref="tabsDashboardView" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill>
						<b-tab title="Kekko è Strunz">
							<template #title> <i class="fas fa-chart-bar mr-2"></i>Anteprima Grafico </template>
							<div style="height: 100%">
								<v-chart ref="cmpGraphics" :not-merge="true" :option="chartOption" autoresize class="sa-widget-chart" />
							</div>
						</b-tab>
						<b-tab title="Dati Query">
							<template #title> <i class="fas fa-table mr-2"></i>Dati Grezzi (Query) </template>
							<div class="b-table-sticky-header">
								<b-table responsive striped hover small :items="this.testData" class="mt-3">
									<template #table-caption>Mostrando i primi 10 record del risultato query.</template>
								</b-table>
							</div>
						</b-tab>
						<b-tab title="Kekko è Strunz">
							<template #title> <i class="fas fa-calculator mr-2"></i>Dati Aggregati </template>
						</b-tab>
					</b-tabs>
				</section>
			</main>
		</div>
	</b-modal>
</template>

<script>
import axios from "axios";
import DataAnalysisChartMixinKekkoStrunz from "../mixins/DataAnalysisChartMixinKekkoStrunz";
import ECharts from "vue-echarts";
import { use } from "echarts/core";

// 2. Importa i moduli di ECharts (necessario per non caricare tutto il pacchetto)
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent } from "echarts/components";
// 3. Registra i moduli
use([CanvasRenderer, BarChart, LineChart, PieChart, GridComponent, TooltipComponent, LegendComponent]);
export default {
	name: "WidgetEditor",
	mixins: [DataAnalysisChartMixinKekkoStrunz],
	props: {
		config: {
			type: Object,
			required: true,
		},
	},
	components: { "v-chart": ECharts },
	created() {
		this.setMxChartConfig(this.config);
	},
	data() {
		return {
			// Clone profondo per evitare mutazioni dirette
			//mxChartConfig: JSON.parse(JSON.stringify(this.config)),
			pathResourceQueryList: "/dataanalysisquery",
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			queryOptions: [],
			testData: [],
			queryResult: [],
			isExecuting: false,
			paletteOptions: [
				{ value: "standard", text: "Standard (Default ECharts)" },
				{ value: "vintage", text: "Vintage (Colori Caldi/Retrò)" },
				{ value: "cool", text: "Cool (Blu/Verdi Professionali)" },
				{ value: "warm", text: "Sunset (Arancio/Rossi Vivaci)" },
				{ value: "neon", text: "Cyberpunk (Colori Neon Accesi)" },
				{ value: "grayscale", text: "Scala di Grigi (Minimalista/Stampa)" },
				{ value: "pastel", text: "Pastello (Morbido/Delicato)" },
				{ value: "nature", text: "Nature (Toni della Terra/Bosco)" },
				{ value: "dark", text: "Oceanic (Toni Scuri/Profondi)" },
				{ value: "corporate", text: "Business Blue (Sfumature Professionali)" },
			],
			// Definiamo i set di colori qui per l'anteprima
			graphicOptions: [
				{ value: null, text: "- Seleziona Tipo -" },
				{ value: "bar", text: "📊 Istogramma (Barre)" },
				{ value: "line", text: "📈 Linee" },
				{ value: "pie", text: "🍕 Torta" },
			],
			timeOptions: [
				{ value: "day", text: "Giorno" },
				{ value: "month", text: "Mese" },
				{ value: "year", text: "Anno" },
			],
			aggregateOptions: [
				{ value: null, text: "Nessuna" },
				{ value: "count", text: "Conteggio (Count)" },
				{ value: "sum", text: "Somma (Sum)" },
				{ value: "avg", text: "Media (Average)" },
				{ value: "min", text: "Minimo" },
				{ value: "max", text: "Massimo" },
			],
			gridOptions: Array.from({ length: 12 }, (_, i) => ({ value: i + 1, text: i + 1 })),
		};
	},
	watch: {
		// Se la config esterna cambia (es. reset), aggiorniamo il locale
		config: {
			handler(newVal) {
				this.mxChartConfig = JSON.parse(JSON.stringify(newVal));
			},
			deep: true,
		},
	},
	computed: {
		isPie() {
			return this.mxChartConfig.graphicType === "pie";
		},
		selectedPaletteColors() {
			return this.palettes[this.mxChartConfig.colorPalette] || this.palettes.standard;
		},
		// Estraiamo dinamicamente i nomi delle colonne dal primo record del test
		fieldOptions() {
			if (this.testData && this.testData.length > 0) {
				return Object.keys(this.testData[0]).map((key) => ({
					value: key,
					text: key,
				}));
			}
			return [];
		},
		// Tutti i campi disponibili nella query
		allFieldOptions() {
			if (this.testData && this.testData.length > 0) {
				return Object.keys(this.testData[0]).map((key) => ({ value: key, text: key }));
			}
			return [];
		},

		// Filtriamo solo i campi che contengono effettivamente numeri
		numericFieldOptions() {
			if (this.testData && this.testData.length > 0) {
				const firstRecord = this.testData[0];
				return Object.keys(firstRecord)
					.filter((key) => {
						const val = firstRecord[key];
						// Un campo è considerato numerico se è un numero o una stringa convertibile in numero
						return typeof val === "number" || (!isNaN(parseFloat(val)) && isFinite(val));
					})
					.map((key) => ({ value: key, text: `# ${key} (Numerico)` }));
			}
			return [];
		},

		// Questa è la select dinamica per il Campo Y
		fieldYOptions() {
			// Se l'aggregazione è "count", mostriamo tutti i campi (perché conta le righe)
			if (this.mxChartConfig.aggregateType === "count") {
				return this.allFieldOptions;
			}
			// Se è sum, avg, min, max, mostriamo solo i campi numerici
			return this.numericFieldOptions;
		},
		// Filtriamo i campi che sembrano date o timestamp (ISO, SQL o Millisecondi)
		dateFieldOptions() {
			if (this.testData && this.testData.length > 0) {
				const firstRecord = this.testData[0];
				return Object.keys(firstRecord)
					.filter((key) => {
						const val = firstRecord[key];
						if (!val) return false;

						// 1. Se è un numero > 10^12 (probabile timestamp in millisecondi)
						if (typeof val === "number" && val > 1000000000000) return true;

						// 2. Se è una stringa, proviamo a parsarla
						if (typeof val === "string") {
							const d = new Date(val.replace(" ", "T")); // Supporto per formato SQL
							return !isNaN(d.getTime()) && val.length >= 8; // Escludiamo numeri brevi
						}

						return false;
					})
					.map((key) => ({ value: key, text: `📅 ${key} (Data/Time)` }));
			}
			return [];
		},

		displayData() {
			if (this.queryResult.isMultiSeries) {
				return this.queryResult;
			}
			return this.queryResult.length > 0 ? this.queryResult : this.widgetData;
		},
	},
	methods: {
		init(mxChartConfig) {
			this.mxChartConfig = JSON.parse(JSON.stringify(mxChartConfig));
			this.queryLoadData();
			this.show();
		},
		loadQueryList() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceQueryList;
			axios.get(link)
				.then((response) => {
					me.queryOptions = response.data.data.list;
					if (this.mxChartConfig.idQuery) {
						//this.testQuery();
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		handleSave() {
			// Se svuotiamo il campo secondario, puliamo anche la granularità
			if (!this.mxChartConfig.fieldGroupSecondary) {
				this.mxChartConfig.timeGranularity = null;
			}
			this.$emit("updateConfig", this.mxChartConfig);
		},
		isNumeric(fieldName) {
			fieldName;
			if (!this.testData.length || !fieldName) return false;
			const val = this.testData[0][fieldName];
			return typeof val === "number" || (!isNaN(parseFloat(val)) && isFinite(val));
		},
		getAvailableAgg(fieldName) {
			fieldName;
			const basic = [{ value: "count", text: "Conteggio (Count)" }];
			if (this.isNumeric(fieldName)) {
				return [...basic, { value: "sum", text: "Somma (Sum)" }, { value: "avg", text: "Media (Avg)" }, { value: "min", text: "Minimo (Min)" }, { value: "max", text: "Massimo (Max)" }];
			}
			return basic;
		},
		onFieldChange(index) {
			index;
			const s = this.mxChartConfig.seriesConfigs[index];
			if (!this.isNumeric(s.field)) s.agg = "count";
		},
		addSeries() {
			this.mxChartConfig.seriesConfigs.push({ field: null, agg: null });
		},
		show() {
			this.$refs.mdlWidgetEditor.show();
		},
		removeSeries() {},
	},
};
// {
//   "id": "widget_multi_serie_001",
//   "title": "Media Valori per Sezione (Trend Mensile)",
//   "idQuery": "d1df2075-4226-42e7-bbfd-fdf518608b0c",
//   "type": "graphic",
//   "graphicType": "line",
//   "colorPalette": "cool",
//   /* Configurazione Aggregazione */
//   "aggregate": true,
//   "aggregateType": "avg",      /* Opzioni: count, sum, avg, min, max */
//   /* Mappatura Campi SQL */
//   "xField": "sezione",             /* Asse X / Legenda */
//   "fieldGroupSecondary": "data_ora",   /* Campo temporale per multiserie */
//   "yField": "valore_misura",       /* Il campo numerico da aggregare */
//   "timeGranularity": "month",          /* Opzioni: day, month, year */
//   /* Layout Dashboard (Grid Bootstrap) */
//   "xs": 12,
//   "sm": 12,
//   "md": 6,
//   "lg": 6,
//   "xl": 6,

//   "position": 1
// }
</script>
<style scoped>
/* 3. Adatta il tuo app-layout */
.app-layout {
	display: flex;
	flex: 1; /* Occupa tutto lo spazio disponibile nel body della modale */
	width: 100%;
	height: 100%; /* Importante per far scorrere la sidebar o il main separatamente */
}

.main-container {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow-y: auto; /* Solo il contenuto principale scorre */
	background-color: #fff;
}

.sidebar {
	width: 320px;
	background-color: #f8f9fa;
	overflow-y: auto;
	height: 100%;
	padding: 10px;
}
.sa-data-analysis-section-header {
	font-size: 0.75rem;
	font-weight: bold;
	text-transform: uppercase;
	color: #6c757d;
	border-bottom: 1px solid #eee;
	padding-bottom: 5px;
	margin-bottom: 15px;
	margin-top: 20px;
}
.sa-data-analysis-series-item {
	background: #ffffff;
	border: 1px solid #e9ecef;
	border-left: 4px solid #007bff;
	border-radius: 8px;
	padding: 15px;
	margin-bottom: 15px;
	position: relative;
	transition: all 0.2s;
}
.sa-data-analysis-series-item:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.sa-data-analysis-remove-btn {
	position: absolute;
	top: 8px;
	right: 10px;
	color: #dc3545;
	cursor: pointer;
	z-index: 5;
}
</style>
